<template>
  <div v-if="element">
    <DateDropdownHint :value="entryItem.dateValue" :placeholder="element.name" @input="changed" />
  </div>
</template>

<script>
import DateDropdownHint from "@/components/date/DateDropdownHint";
export default {
  name: "DateField",
  props: ["element", "entryItems"],
  components: {
    DateDropdownHint
  },
  computed: {
    entryItem() {
      if (!this.entryItems) {
        return undefined;
      }
      return this.entryItems[this.element.id];
    }
  },
  data() {
    return {
      timerId: null
    };
  },
  methods: {
    changed(e) {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // console.log(value)
        let copy = JSON.parse(JSON.stringify(this.entryItems));
        if (copy[this.element.id]) {
          copy[this.element.id].dateValue = e;
          this.$emit("updated", copy);
        }
      }, 500);
    }
  }
};
</script>